module.exports = __webpack_public_path__ + "static/media/writingLines.9c134861.svg";